import { addPageAction } from './new_relic';

export const openSUSILightDialog = (signInURL, onClose) => {
  const susiLight = document.querySelector('susi-sentry-light');

  if (!susiLight) {
    /**
     * This means the SUSI Light flipper flag is not enabled;
     * or there was an issue loading the SUSI Sentry Light component;
     * Redirect the user to the original IMS sign-in workflow,
     * but our app will not capture the new token when the user is redirected back,
     * instead it loads the visitor version of the site and then captures the token
     * after a second page reload
     *
     * Redirect user with the provided ims_login_url ensures both front and backend will receive
     * the new token at the same time when they are redirected back to tk/tk
     */
    window.location.href = signInURL;
  }

  const dialog = document.getElementById('sentry-dialog');
  if (!dialog || dialog.open) {
    return;
  }

  dialog.showModal();
  if (onClose) {
    dialog.addEventListener('close', onClose);
  }
};

export const initSignUpButtonHandlers = () => {
  const signUpButton = document.querySelector('.susi-light--signup-button');
  if (!signUpButton) {
    return null;
  }

  const clickHandler = () => {
    // Adding this page action since the original sign up button is no longer an anchor element
    // The original analytics are no longer captured in this case.
    addPageAction('typekit.susi-light.sign-up-button.click');
    openSUSILightDialog(signUpButton.getAttribute('sign-up-url'));
  };

  signUpButton.addEventListener('click', clickHandler);
};

export const initSignInButtonHandlers = () => {
  const signInButton = document.querySelector('#adobe-fonts--signin-button');
  if (!signInButton) {
    return null;
  }

  const clickHandler = () => {
    openSUSILightDialog(signInButton.getAttribute('sign-in-url'));
  };

  signInButton.addEventListener('click', clickHandler);
};

export const initCloseButtonHandlers = () => {
  const closeButton = document.getElementById('af-susi-light-dialog__close-button');
  if (!closeButton) {
    return;
  }

  const clickHandler = () => {
    const dialog = document.getElementById('sentry-dialog');
    if (dialog) {
      addPageAction('typekit.susi-light.close-button.click');
      dialog.close();
    }
  };

  closeButton.addEventListener('click', clickHandler);
};

/**
 * Initializes the SUSI Light dialog by adding event listeners to the sign up and sign in buttons.
 *
 * @returns {void}
 */
export const initSUSILight = () => {
  initSignInButtonHandlers();
  initSignUpButtonHandlers();
  initCloseButtonHandlers();
};
